import React, { useEffect, useRef, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import PropTypes from "prop-types";

import { AppForm } from "../../forms/AppForm";
import { AppSelect } from "../../forms/AppSelect";
import { AppInput } from "../../forms/AppInput";
import { AppSubmit } from "../../forms/AppSubmit";
import { GET_CITY_BY_STATE } from "../../Graphql/queries/queryGetCityByState";
import { GET_EPS_BY_CITY } from "../../Graphql/queries/queryGetEpsByCity";
import { IconCheckboxChecked } from "../Icons/IconCheckboxChecked";
import { IconCheckboxUnchecked } from "../Icons/IconCheckboxUnchecked";
import { useToastError } from "../../Hooks/useToastError";
import { useToastInfo } from "../../Hooks/useToastInfo";
import { Variables } from "../../styles/Variables";
import IconUpload from "../Icons/IconUpload";
import ModalAuthYounger from "../../Modals/ModalAuthYounger";
import ModalInformation from "../../Modals/ModalInformation";
import ModalTermsAffiliation from "../../Modals/ModalTermAndConditions/ModalTermsAffiliation";
import PrimaryNormal from "../buttons/PrimaryNormal";

import {
  ContainerInput,
  ContainerInputs,
  ContainerTerms,
  InfoTerms,
  ContainerBar,
  NameFile,
  ContainerTextMail,
  TextH3,
  TextInfo,
  ContainerBackForm,
} from "../../styles/PageStyles/Health/StylesAffiliateHealthForm";
import useScreenSize from "../../Hooks/useScreenSize";

const AffiliationToHealthForm = ({
  handleSubmit,
  dataState,
  dataDocumentType,
  setLocation,
  setPickers,
  setDocument,
  color,
  validationSchema,
  setFile,
  file,
  adultInfo,
  setAdultInfo,
  old,
}) => {
  /* eslint-disable */
  const CEDULA_ID = process.env.REACT_APP_CEDULA_ID;
  const SITE_KEY = process.env.REACT_APP_SITE;
  /* eslint-enable */
  const { width } = useScreenSize();
  const showToastInfo = useToastInfo();
  const hiddenFileInput = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalYounger, setModalYounger] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);
  const [terms, setTerms] = useState(false);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [eps, setEps] = useState("");
  const [gender, setGender] = useState(null);
  const [typeDocument, setTypeDocument] = useState(null);
  const [dependent, setDependent] = useState(null);
  const [nameFiles, setNameFiles] = useState(null);
  const [deployColor, setDeployColor] = useState(false);
  const toastInfo = useToastInfo();

  // Query para traer las ciudades según el departamento
  const [sendState, { error, data }] = useLazyQuery(GET_CITY_BY_STATE);
  // Query para traer las eps según la ciudad
  const [sendCity, { error: errorCity, data: dataEps }] = useLazyQuery(GET_EPS_BY_CITY);
  // Filtro para exceptuar la cédula de ciudadanía colombiana en caso de ser menor
  const DocumentsTypes = dataDocumentType.filter((doc) => doc.id !== CEDULA_ID);

  // Mostrar errores si hay en alguna query
  useToastError(error || errorCity);

  // Efecto para leer si es mayor de edad y abrir modal en caso de no serlo
  useEffect(() => {
    if (old !== null && old === false) {
      setModalYounger(true);
    }
  }, [old]);

  // Código para añadir recaptcha
  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, [SITE_KEY]);

  // Efecto para detectar los cambios en los estados State, City, typeDocument, gender, dependent, dataAdult
  useEffect(() => {
    if (state !== "" && city !== "" && eps !== "") {
      setLocation({
        state: state,
        city: city,
        eps: eps,
      });
    }
    if (state !== "" && city !== "") {
      // Ejecutar query de las epss según la ciudad seleccionada
      sendCity({
        variables: {
          cityId: city,
        },
      });
    }
    if (state !== "") {
      // Ejecutar query de las ciudades según es departamento seleccionado
      sendState({
        variables: {
          stateId: parseInt(state),
        },
      });
    }
    if (typeDocument !== null) {
      setDocument(typeDocument);
    }
    if (gender !== null || dependent !== null) {
      setPickers({
        gender: gender,
        dependentChildren: dependent,
      });
    }
    // if (Object.keys(adultInfo).length === 0) {
    //   // En caso de que sea un registro de menor Guardar datos del padre en el estado AdultInfo
    //   setAdultInfo(dataAdult);
    // }
  }, [state, city, eps, gender, dependent, typeDocument, sendState, sendCity, setDocument, setLocation, setPickers]);

  // Estancias de datos de las query's
  const cities = data?.getCitiesByState.data;
  const epss = dataEps?.getEpsByCity.data;
  const emailCity = cities?.find((c) => c.id === city);
  const newEps = epss?.map((item) => {
    return {
      id: item.eps.id,
      name: item.eps.name,
    };
  });

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  // Función mejorada para manejar archivos
  const handleFileChange = (event) => {
    event.preventDefault();
    const files = Array.from(event.target.files);

    // Validaciones de archivos
    if (files.length === 0) return;

    if (files.length > 2) {
      toastInfo("Solo puedes subir como máximo 2 imágenes o 1 pdf");
      return;
    }

    const isPDF = files.some((file) => file.type === "application/pdf");
    const areImages = files.every((file) => file.type.startsWith("image/"));

    if (isPDF && files.length > 1) {
      toastInfo("Solo puedes subir 1 pdf o 2 imágenes");
      return;
    }

    if (!isPDF && !areImages) {
      toastInfo("Solo se permiten archivos PDF o imágenes");
      return;
    }

    // Actualizar estados
    setNameFiles(files.map((file) => file.name).join(", "));
    setFile(files); // Este setFile viene como prop y actualiza el estado en el componente padre
    setDeployColor(true);
  };

  // función para render de mensaje con correos necesarios para documentos.
  const validationCity = () => {
    if (city !== "") {
      return (
        <>
          {emailCity?.email ? (
            <div>
              <div style={{ boxSizing: "border-box", width: "100%", textAlign: "center", marginTop: 20 }}>
                Debes guardar este correo para enviar otros documentos necesarios:{" "}
                <h3 style={{ boxSizing: "border-box", width: "100%", color: "red", overflowWrap: "break-word" }}>
                  {emailCity.email}
                </h3>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ boxSizing: "border-box", width: "100%", textAlign: "center", marginTop: 20 }}>
                Debes guardar este correo para enviar otros documentos necesarios:{" "}
                <h3 style={{ boxSizing: "border-box", width: "100%", color: "red", overflowWrap: "break-word" }}>
                  gestiondocumental@antioquia.gov.co
                </h3>
              </div>
            </div>
          )}
        </>
      );
    }
  };

  return (
    <ContainerBackForm>
      <AppForm
        initialValues={{
          documentNumber: "",
          email: "",
          name: "",
          lastName: "",
          phoneNumber: "",
          secondaryPhoneNumber: "",
          whatsAppPhoneNumber: "",
          neighborhood: "",
          birthday: "",
          documentExpirationDate: "",
        }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        <ContainerInputs>
          <ContainerInput>
            {console.log(DocumentsTypes + "\n" + dataDocumentType)}
            <AppSelect
              label="Tipo de documento(*)"
              name="documentType"
              data={old !== null && old === false ? DocumentsTypes : dataDocumentType}
              value={typeDocument}
              onChange={(e) => setTypeDocument(e.target.value)}
              style={{ height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Número de documento(*)"
              placeholder="Número de documento(*)"
              name="documentNumber"
              style={{ height: "28px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Fecha de expedición(*)"
              placeholder="Fecha de expedición(*)"
              name="documentExpirationDate"
              type="date"
              style={{ height: "30px" }}
            />
          </ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput>
            <NameFile>{nameFiles && file?.length === 2 ? `${nameFiles}, +1` : nameFiles}</NameFile>
            <PrimaryNormal
              title="Agregar documento(*)"
              icon={<IconUpload />}
              onClick={() => setModalInfo(true)}
              type="button"
              style={{
                marginTop: 21,
                backgroundColor: deployColor ? Variables.colorGreenSuccess : Variables.colorOrange,
                color: Variables.colorBlackDark,
                height: 30,
                borderColor: Variables.colorBlack,
                borderWidth: 2,
                borderStyle: "solid",
              }}
            />
            <ModalInformation modalOpen={modalInfo} notClose>
              <TextInfo>
                ¡Recuerda! que el archivo o imagen que vas a agregar debe coincidir con la opción elegida en el tipo de
                documento de este mismo formulario.
              </TextInfo>
              <PrimaryNormal
                style={{ width: "50%", marginLeft: "25%", backgroundColor: Variables.colorOrange }}
                title="Aceptar"
                onClick={() => {
                  setModalInfo(false);
                  handleClick();
                }}
              />
            </ModalInformation>
            <input
              type="file"
              ref={hiddenFileInput}
              onChange={handleFileChange}
              style={{ display: "none" }}
              accept="image/*,.pdf"
              multiple
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Correo electrónico(*)"
              placeholder="Correo electrónico(*)"
              name="email"
              style={nameFiles && file ? { height: "30px", marginTop: 18, borderWidth: 1 } : { height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput></ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput></ContainerInput>
          <ContainerBar src="/home/barGray.png" />
          <ContainerInput></ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput>
            <AppSelect
              label="Departamento(*)"
              name="state"
              data={dataState}
              value={state}
              onChange={(e) => setState(e.target.value)}
              info={true}
              style={{ height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppSelect
              label="Municipio(*)"
              name="city"
              data={cities || []}
              value={city}
              onChange={(e) => setCity(e.target.value)}
              info={true}
              style={{ height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppSelect
              label="Selecciona una E.P.S (*)"
              name="eps"
              data={newEps || []}
              value={eps}
              onChange={(e) => setEps(e.target.value)}
              style={{ height: "30px" }}
            />
          </ContainerInput>
        </ContainerInputs>
        <ContainerTextMail>{validationCity()}</ContainerTextMail>
        <ContainerInputs>
          <ContainerInput></ContainerInput>
          <ContainerBar src="/home/barGray.png" />
          <ContainerInput></ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput>
            <AppInput
              label="Nombre(*)"
              name="name"
              style={width <= 1024 ? { height: "30px", marginTop: 18, borderWidth: 1 } : { height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Apellidos(*)"
              name="lastName"
              style={width <= 1024 ? { height: "30px", marginTop: 18, borderWidth: 1 } : { height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Número de teléfono fijo/celular para contactarme (1)*"
              name="phoneNumber"
              style={{ height: "30px" }}
            />
          </ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput>
            <AppInput
              label="Número de teléfono fijo/celular de un amigo o familiar (2)*"
              name="secondaryPhoneNumber"
              style={{ height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="WhatsApp (añadir indicativo si es internacional)"
              name="whatsAppPhoneNumber"
              placeholder="Ejm: +57 300XXX0000"
              style={{ height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Barrio/Dirección(*)"
              name="neighborhood"
              style={width <= 1024 ? { height: "30px", marginTop: 16, borderWidth: 1 } : { height: "30px" }}
            />
          </ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput>
            <AppSelect
              label="Sexo(*)"
              name="gender"
              data={[
                { id: "MALE", name: "Masculino" },
                { id: "FEMALE", name: "Femenino" },
              ]}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              style={width <= 1024 ? { height: "30px", marginTop: 18, borderWidth: 1 } : { height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppInput
              label="Fecha de nacimiento(*)"
              name="birthday"
              type="date"
              style={width <= 1024 ? { height: "30px", marginTop: 18, borderWidth: 1 } : { height: "30px" }}
            />
          </ContainerInput>
          <ContainerInput>
            <AppSelect
              label="Tienes personas a cargo ó eres cabeza de hogar(*)"
              name="dependentChildren"
              data={[
                { id: true, name: "Si" },
                { id: false, name: "No" },
              ]}
              value={dependent}
              onChange={(e) => setDependent(e.target.value)}
              style={{
                height: "30px",
              }}
            />
          </ContainerInput>
        </ContainerInputs>
        <ContainerInputs>
          <ContainerInput>
            {terms ? (
              <ContainerTerms>
                <div>
                  <IconCheckboxChecked />
                </div>
                <InfoTerms onClick={() => setModalVisible(true)}>
                  Antes de guardar tu información lee atentamente tus compromisos para que tu afiliación al sistema de
                  salud, permanezca vigente <TextH3>AQUÍ</TextH3>.
                </InfoTerms>
              </ContainerTerms>
            ) : (
              <ContainerTerms>
                <div>
                  <IconCheckboxUnchecked />
                </div>
                <InfoTerms onClick={() => setModalVisible(true)}>
                  Antes de guardar tu información, lee atentamente tus compromisos para que tu afiliación al sistema de
                  salud, permanezca vigente <TextH3>AQUÍ</TextH3>.
                </InfoTerms>
              </ContainerTerms>
            )}
          </ContainerInput>
          <ContainerInput></ContainerInput>
          <ContainerInput>
            {terms ? <AppSubmit title="Guardar" style={{ backgroundColor: color }} form={true} /> : <ContainerInput />}
          </ContainerInput>
        </ContainerInputs>
      </AppForm>
      <ModalAuthYounger
        modalVisible={modalYounger}
        setModalVisible={setModalYounger}
        documentTypes={dataDocumentType}
        dataAdult={adultInfo}
        setDataAdult={setAdultInfo}
      />
      <ModalTermsAffiliation
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        press={() => {
          setTerms(true);
          setModalVisible(false);
        }}
        pressNo={() => {
          setTerms(false);
          setModalVisible(false);
          showToastInfo("Upps, para guardar la información debes aceptar los términos.");
        }}
      />
    </ContainerBackForm>
  );
};

AffiliationToHealthForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  color: PropTypes.string,
  validationSchema: PropTypes.object,
  dataState: PropTypes.array,
  dataDocumentType: PropTypes.array,
  dataCity: PropTypes.array,
  setLocation: PropTypes.func,
  setPickers: PropTypes.func,
  setDocument: PropTypes.func,
  setFile: PropTypes.func,
  file: PropTypes.array,
  adultInfo: PropTypes.object,
  setAdultInfo: PropTypes.func,
  old: PropTypes.bool,
};

export default AffiliationToHealthForm;
